import { ReactNode, useMemo } from "react";
import { Link } from "react-router-dom";
import TaxonomyTrail from "./right-side/taxonomy-trail";
import NewsTrail, { detailPageNewsTrailType } from "./right-side/news-trail";
import { useState } from "react";
import LayoutTop from "./right-side/layout-top";
import { TaxonomyType } from "../../models/taxonomy-model";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import LoadHomeSideGoogleAds from "../../components/advertisement/load-home-side-google-ads";
type TwoColumnLayOutTypes = {
  breadcrumbPath: string;
  isBreadcrumbpath: boolean;
  tabs?: {
    isTabs: boolean;
    tab1: {
      title: string;
      content: string;
    };
    tab2: {
      title: string;
      content: string;
    };
  };
  siteTop?: JSX.Element;
  children: ReactNode;
  detailPageTaxonomy?: TaxonomyType[];
  detailPageNewsTrail?: detailPageNewsTrailType | undefined;
  showAds?: boolean;
  showAdsOutside?: boolean;
  customUseDfpSlot?: JSX.Element;
  newsArticleDetailAds?: JSX.Element;
  isSubscribeButton?: boolean;
  isDetails?: boolean;
  addSchema?: boolean;
  schemaOptions?: {
    itemType: string;
  };
};

const TwoColumnLayOut = (props: TwoColumnLayOutTypes): JSX.Element => {
  const [isActive, setIsActive] = useState<string>("tab1");
  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedUseDfpSlot = useMemo(() => (props.customUseDfpSlot !== undefined ? props.customUseDfpSlot : <LoadHomeSideGoogleAds />), []);
  const showAdsOutside = props.showAdsOutside === undefined ? false : props.showAdsOutside;

  return (
    <>
      <main id="site-main" className="site-main container-off" role="main">
        <div className="site-top">{props.siteTop !== undefined && props.siteTop}</div>
        <LayoutTop breadcrumbPath={props.breadcrumbPath} isBreadcrumbpath={props.isBreadcrumbpath} />
        <div className="container two-column" itemScope={props.addSchema ? true : undefined} itemType={props.addSchema && props.schemaOptions?.itemType ? props.schemaOptions.itemType : undefined}>
          <div className="row">
            <div className="col-md-9">
              <div className="mobile-jump-links">
                <ul className="list-unstyled">
                  <li>
                    <a href="#navRail">
                      Skip to Navigation{" "}
                      <svg className="icomoon icomoon-circle-down">
                        <use xlinkHref="#icomoon-circle-down"></use>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>

              {props.children}

              {/* Tabs */}
              {props.tabs?.isTabs ? (
                <div className="widget">
                  <div className="tabs tabs-responsive">
                    <div className="responsive-tabs-container">
                      <ul className="nav nav-tabs " id="pagetab">
                        {props.tabs.tab1.title ? (
                          <li
                            role="presentation"
                            className={isActive === "tab1" ? "active" : ""}
                            onClick={() => {
                              setIsActive("tab1");
                            }}
                          >
                            <Link to="#">
                              <span>{props.tabs.tab1.title}</span>
                            </Link>
                          </li>
                        ) : null}
                        {props.tabs.tab2.title ? (
                          <li
                            role="presentation"
                            className={isActive === "tab2" ? "active" : ""}
                            onClick={() => {
                              setIsActive("tab2");
                            }}
                          >
                            <Link to="#" aria-controls="39" role="tab">
                              <span>{props.tabs.tab2.title}</span>
                            </Link>
                          </li>
                        ) : null}
                      </ul>
                      <div className="tab-content">
                        {props.tabs.tab1.title ? (
                          <>
                            <Link
                              to="#"
                              className={`accordion-link ${isActive === "tab1" ? "active" : ""}`}
                              onClick={() => {
                                setIsActive("tab1");
                              }}
                            >
                              {" "}
                              <span>{props.tabs.tab1.title}</span>
                            </Link>
                            <div role="tabpanel" className={`tab-pane ${isActive === "tab1" ? "active" : ""}`} id="121">
                              <div className="tab-pane-inner">
                                <div dangerouslySetInnerHTML={{ __html: props.tabs.tab1.content }}></div>
                              </div>
                            </div>
                          </>
                        ) : null}

                        {props.tabs.tab2.title ? (
                          <>
                            <Link
                              to="#"
                              className={`accordion-link ${isActive === "tab2" ? "active" : ""}`}
                              onClick={() => {
                                setIsActive("tab2");
                              }}
                            >
                              <span>{props.tabs.tab2.title}</span>
                            </Link>
                            <div role="tabpanel" className={`tab-pane ${isActive === "tab2" ? "active" : ""}`} id="39">
                              <div className="tab-pane-inner">
                                <div dangerouslySetInnerHTML={{ __html: props.tabs.tab2.content }}></div>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {props.newsArticleDetailAds !== undefined && props.newsArticleDetailAds}
            </div>

            <div className="col-md-3">
              <div className="col-md-12 rightrail">
                {props.isSubscribeButton && (
                  <div className="subscribe-btn text-center">
                    <Link className="btn btn-default btn-responsive" to="/preferences">
                      Subscribe
                    </Link>
                  </div>
                )}
                <TaxonomyTrail detailPageTaxonomy={props.detailPageTaxonomy} addSchema={props.addSchema} />
                <NewsTrail detailPageNewsTrail={props.detailPageNewsTrail} isDetails={props.isDetails} />
              </div>
            </div>
          </div>
          <p>&nbsp;</p>
          {props.showAds !== undefined && !showAdsOutside && props.showAds && cachedGoogleAds}
          {props.showAds !== undefined && !showAdsOutside && cachedUseDfpSlot}
          <p>&nbsp;</p>
        </div>
        {props.showAds !== undefined && showAdsOutside && props.showAds && cachedGoogleAds}
        {props.showAds !== undefined && showAdsOutside && cachedUseDfpSlot}
        {props.showAds !== undefined && showAdsOutside && (
          <>
            <p>&nbsp;</p>
          </>
        )}
      </main>
    </>
  );
};

export default TwoColumnLayOut;
